export default __webpack_public_path__ + "static/media/success.8a124e17.svg";